<template>
    <div class="report">
        <router-view></router-view>
    </div>
</template>

<script type="text/javascript">
import { mapState } from 'vuex';
import TabBar from '../TabBar';
import store from '../../store.js';

export default {
    components: {
        TabBar
    }
};
</script>

<style lang="scss"></style>


// WEBPACK FOOTER //
// src/components/report/Report.vue